module.exports = __webpack_public_path__ + "static/media/inst-icon.35ca2fc4.svg";